import React, { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import contents from '../../routes/contentRoutes';
import { getLoginObjDetails } from '../../redux/login/login.selector';
import { hasRouteAccess } from '../../common/function/menuAccess';

const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));

/**
 * RBAC route guard. Hiding a menu item is not access control — without this a
 * user could simply type the URL of a page they were never granted. Admins
 * (Level100/Level4) bypass; ungoverned routes (dashboard, profile, auth) are
 * always allowed; a role with no grants at all falls back to legacy access so
 * an unseeded tenant is never locked out. Denied users land on the dashboard,
 * which is ungoverned and therefore cannot loop.
 */
const Guard = ({ path, children }: { path: string; children: React.ReactNode }) => {
	const loginData = useSelector(getLoginObjDetails);
	if (!hasRouteAccess(loginData, path)) {
		return <Navigate to='/' replace />;
	}
	return <>{children}</>;
};

const ContentRoutes = () => {
	return (
		<Routes>
			{contents.map((page: any) => (
				<Route
					key={page.path}
					{...page}
					element={<Guard path={page.path}>{page.element}</Guard>}
				/>
			))}
			<Route path='*' element={<PAGE_404 />} />
		</Routes>
	);
};

export default ContentRoutes;
